import styled from "styled-components"

export const Totals = styled.div`
  ${(p) => p.theme.bold}
`

export const Label = styled.div`
  ${(p) => p.theme.bold}
  font-size: 1.6rem;
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding-left: 2rem;
`

export const IconWrapper = styled.div`
  display: none;
  height: 100%;

  align-items: center;

  svg {
    height: 2.8rem;
    margin-right: 0.5rem;
    margin-left: 1.5rem;
  }

  ${(p) => p.theme.mQ.MEDIA_MIN_MEDIUM} {
    display: flex;
  }
`
